import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { isMobile } from 'react-device-detect'
import { commonActions, alertActions, certboxActions } from '../../../../store/actions'
import moment from 'moment'

const CertboxUploadDoc = (props) => {
  const [fileList, setFileList] = useState([])
  const [fileDelList, setFileDelList] = useState([])
  const fileRef = React.useRef(new Array(10))
  const [tempIdx, setTempIdx] = useState(0)
  const [mobile, setMobile] = useState(false)
  const [fileInfo, setFileInfo] = useState({
    fileName: '',
    filePath: '',
    fileSize: '',
    index: 0,
  })

  useEffect(() => {
    setMobile(isMobile)
    let indexNew = 0
    let emptyList = []

    for (let cont of props.data[0].fileNewList) {
      emptyList.push({
        docKey: indexNew,
        docFileName: cont.originFileNm,
        docFile: '',
        docYn: 'Y',
        contentId: cont.contentId,
      })

      indexNew++
    }
    setFileList(emptyList)
    setTempIdx(indexNew)
  }, [])

  const handleClose = () => {
    props.onClose()
  }

  // 줄추가시
  const addRow = () => {
    // 임시로 첨부파일 갯수 10개로 막아놓음
    if (tempIdx > 9) {
      props.error({ message: '파일은 최대 10개까지만 추가 가능합니다.' })
      return
    }

    let emptyList = []

    emptyList.push({
      docKey: tempIdx,
      docFileName: '',
      docFile: '',
      docYn: 'N',
      contentId: '',
    })

    setFileList([...fileList, ...emptyList])

    setTempIdx(tempIdx + 1)
  }

  // 줄제거시
  const deleteRow = (docKey) => {
    let changeList = fileList.filter((file) => file.docKey !== docKey)
    let delList = fileList.filter((file) => file.docKey === docKey)

    let emptyList = fileDelList
    console.log('emptyList', emptyList)
    for (let cont of delList) {
      if (cont.docYn === 'Y') {
        emptyList.push(cont)
      }
    }
    setTempIdx(changeList.length)
    setFileList(changeList)
    setFileDelList(emptyList)
  }

  const setFile = (e, i) => {
    if (e.target?.files.length < 1) return

    if (e.target?.files[0].name.toLowerCase().indexOf('pdf') !== -1) {
      fileList[i] = {
        docFileName: e.target?.files[0].name,
        docFile: e.target?.files[0],
        docKey: e.target.id,
        docYn: 'N',
        contentId: '',
      }

      setFileList([...fileList])
    } else {
      props.error({ message: 'PDF 파일이 아닙니다.' })
      return
    }
  }

  const setMobileFile = (i) => {
    window.M.execute(
      'exWNOpenAttachSelector',
      window.M.response
        .on(function (status, result) {
          console.log(status)
          console.log(result)
          var fileName = result.fileName
          if (fileName.toLowerCase().indexOf('pdf') != -1) {
            setFileInfo({
              ...fileInfo,
              fileName: result.fileName,
              filePath: result.filePath,
              fileSize: result.fileSize,
              index: i,
            })
          } else {
            props.error({ message: 'PDF 파일이 아닙니다.' })
            return
          }
        })
        .toString(),
    )
  }

  /*  useEffect(() => {
    fileList[fileInfo.index] = {
      docFileName: fileInfo.fileName,
      docFile: fileInfo.filePath,
      docKey: fileInfo.index,
    }

    setFileList([...fileList])
  }, [fileInfo])*/

  useEffect(() => {
    if (props.isUpload) {
      props.success({
        title: '파일업로드성공',
        message: '성공적으로 업로드되었습니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.location.href = '/service/certbox'
          },
        },
      })
    }
  }, [props.isUpload])

  const onUpload = () => {
    // 증명서 파일 업로드
    // 1. 업로드 파일여부 확인
    // 2. 증명서 파일 업로드 api 호출(처리결과 메시지 출력)
    // 3. 목록으로 이동

    if (fileList.length < 1) {
      props.error({ message: '업로드 대상 파일이 존재하지 않습니다.' })
      return
    } else {
      let uploadObj = {
        crtSeq: props.data.map((param) => param.crtSeq),
        contentIds: fileDelList.map((param) => param.contentId),
        files: fileList,
      }
      console.log('uploadObj', uploadObj)
      console.log('fileDelList', fileDelList)
      props.createCrtfUpload(uploadObj)
    }
  }

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '11',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '12',
    display: 'block',
  }
  let styleOff = {
    display: 'none',
  }

  return (
    <React.Fragment>
      {/* 내문서 업로드 */}
      <div style={style}></div>
      <div style={styleModal} id="document-register" className="modal w1120">
        <div className="modal-head">
          <h3 className="h3-tit first">선택한 증명서</h3>
        </div>
        <div className="modal-cont mobile-scroll">
          <table className="tbl-list">
            <caption>증명서 및 발급번호, 발급일시, 발급번호, 발급처 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '25%' }} />
              <col style={{ width: '25%' }} />
              <col style={{ width: '25%' }} />
              <col style={{ width: '25%' }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">증명서 및 발급번호</th>
                <th scope="col">발급일시</th>
                <th scope="col">발급번호</th>
                <th scope="col">발급처</th>
              </tr>
            </thead>
            <tbody>
              {props.data?.length > 0 ? (
                props.data?.map((certboxInfo, index) => (
                  <tr key={index}>
                    <td className="cell" data-title={'증명서 및 발급번호'}>
                      {certboxInfo.crtNm} <span className="txt1">{certboxInfo.docid}</span>
                    </td>
                    <td className="cell" data-title={'발급일시'}>
                      {moment(certboxInfo.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD HH:mm:ss')}
                    </td>
                    <td className="cell" data-title={'발급번호'}>
                      {certboxInfo.docid}
                    </td>
                    <td className="cell" data-title={'발급처'}>
                      {certboxInfo.prchsNm}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    <div className="nodata">등록된 자료가 없습니다.</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="btn-block center">
            <a href="#" className="btn-primary md" onClick={addRow}>
              파일추가
            </a>
          </div>
        </div>
        <div className="modal-cont mobile-scroll">
          <div className="tbl-wrap">
            <table className="tbl-list">
              <caption>파일명, 파일등록/삭제 항목으로 구성</caption>
              <colgroup>
                <col style={{ width: '50%' }} />
                <col style={{ width: '50%' }} />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">파일명</th>
                  <th scope="col">파일등록/삭제</th>
                </tr>
              </thead>
              <tbody>
                {fileList?.length > 0 ? (
                  fileList?.map((file, index) => (
                    <tr key={index}>
                      <td className="cell" data-title={'파일명'}>
                        {file.docFileName}
                      </td>
                      <td className="cell" data-title={'삭제'}>
                        {mobile ? (
                          <div>
                            <a href="#" className="btn-secondary md" onClick={() => setMobileFile(index)}>
                              파일첨부
                            </a>
                            <a href="#" className="btn-secondary md" onClick={() => deleteRow(file.docKey)}>
                              삭제하기
                            </a>
                            <input
                              title="첨부파일"
                              type="file"
                              ref={(ref) => (fileRef.current[index] = ref)}
                              name="docFile"
                              id={file.docKey}
                              style={styleOff}
                              accept=".pdf"
                              onChange={(e) => setFile(e, index, file.docKey)}
                            />
                          </div>
                        ) : (
                          <div>
                            {file.docYn === 'N' ? (
                              <a href="#" className="btn-secondary md" onClick={() => fileRef.current[index].click()}>
                                파일첨부
                              </a>
                            ) : (
                              ''
                            )}
                            <a href="#" className="btn-secondary md" onClick={() => deleteRow(file.docKey)}>
                              삭제하기
                            </a>
                            <input
                              title="첨부파일"
                              type="file"
                              ref={(ref) => (fileRef.current[index] = ref)}
                              name="docFile"
                              id={file.docKey}
                              style={styleOff}
                              accept=".pdf"
                              onChange={(e) => setFile(e, index, file.docKey)}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2}>
                      <div className="nodata">등록된 자료가 없습니다.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="modal-foot">
          <a href="#" className="btn-secondary md" onClick={handleClose}>
            취소
          </a>
          <a
            href="#"
            className="btn-primary md"
            onClick={(e) => {
              e.preventDefault()
              onUpload('A')
            }}
          >
            파일등록
          </a>
        </div>
        <button type="button" className="modal-close b-close" onClick={handleClose}>
          창닫기
        </button>
      </div>
      {/* //내문서 업로드 */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    commoncode: state.commoncode,
    isUpload: state.certbox?.isUpload,
  }
}

const actionCreators = {
  error: alertActions.error,
  success: alertActions.success,
  common: commonActions.getCommonCode,
  createCrtfUpload: certboxActions.createCrtfUpload,
}

export default connect(mapStateToProps, actionCreators)(CertboxUploadDoc)
